const isCommunicationParameter = (parameter = {}) =>
  String(parameter.id || '').trim().toLowerCase() === 'communication' ||
  String(parameter.name || '').trim().toLowerCase() === 'communication'

const formatScore = (value, suffix = '/100') => {
  if (value == null || value === '') return 'Not available'
  const score = Number(value)
  return Number.isFinite(score) ? `${Math.round(score)}${suffix}` : 'Not available'
}

const communicationVerdict = (parameter = {}) => {
  const score = Number(parameter.score)
  if (parameter.score == null || !Number.isFinite(score)) return 'Not enough speech data'
  if (score >= 85) return 'Excellent communicator'
  if (score >= 70) return 'Strong communicator'
  if (score >= 55) return 'Effective communicator'
  if (score >= 40) return 'Developing communicator'
  return 'Needs communication support'
}

const communicationMetrics = (parameter = {}) => {
  if (!isCommunicationParameter(parameter)) return []
  const metrics = parameter.sub_parameters || {}
  return [
    { label: 'Pronunciation & Intelligibility', value: formatScore(metrics.pronunciationIntelligibility ?? metrics.averageWordConfidence ?? metrics.pronunciationConfidence) },
    { label: 'Fluency & Pace', value: formatScore(metrics.fluencyPace ?? metrics.fluency) },
    { label: 'Language Proficiency', value: formatScore(metrics.languageProficiency) },
    { label: 'Clarity & Conciseness', value: formatScore(metrics.clarityConciseness) },
  ]
}

module.exports = {
  communicationMetrics,
  communicationVerdict,
  formatScore,
  isCommunicationParameter,
}
